import {
  IRequestConfig,
  IRequestOptions,
  ShApiResponse_GetFollowUpReportDto,
  ShApiResponse_GetLatestFirmwareDto,
  ShApiResponse_IEnumerable_GetStaticLinksByRoleDto,
  ShApiResponse_IEnumerable_GetStaticLinksDto,
  ShApiResponse_List_String,
  ShApiResponse_String,
  axios,
  basePath,
  getConfigs,
} from "./index.defs";

export class InfoApiService {
  /** Generate by swagger-axios-codegen */
  // @ts-nocheck
  /* eslint-disable */

  /**
   * Get Urls based on the given language
   */
  static infoGetStaticLinks(
    params: {
      /** Type of the requested device IOS/Android */
      deviceType: string;
      /** access token */
      authorization?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_IEnumerable_GetStaticLinksDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/info/staticlinks";

      options.headers = {
        Authorization: params["authorization"],
        ...options.headers,
      };
      const configs: IRequestConfig = getConfigs(
        "get",
        "application/json",
        url,
        options
      );
      configs.params = { deviceType: params["deviceType"] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Get Urls based on passed role ID
   */
  static infoGetStaticLinksByRole(
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_IEnumerable_GetStaticLinksByRoleDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/info/links";

      const configs: IRequestConfig = getConfigs(
        "get",
        "application/json",
        url,
        options
      );

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Get a list of the user allowed reports
   */
  static infoGetUserReportTypes(
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_List_String> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/info/reports/type";

      const configs: IRequestConfig = getConfigs(
        "get",
        "application/json",
        url,
        options
      );

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Get a list of pro users under the organization
   */
  static infoGetOrganizationProUsersReport(
    params: {
      /**  */
      studyId?: string;
      /**  */
      onlyActiveUsers?: boolean;
      /** access token */
      authorization?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_GetFollowUpReportDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/info/reports/users/pro";

      options.headers = {
        Authorization: params["authorization"],
        ...options.headers,
      };
      const configs: IRequestConfig = getConfigs(
        "get",
        "application/json",
        url,
        options
      );
      configs.params = {
        studyId: params["studyId"],
        onlyActiveUsers: params["onlyActiveUsers"],
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Get a list of non pro users
   */
  static infoGetNonProUsersReportByEntity(
    params: {
      /**  */
      distId: number;
      /**  */
      onlyActiveUsers?: boolean;
      /** access token */
      authorization?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_GetFollowUpReportDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/info/reports/users/non-pro/entity/{distId}";
      url = url.replace("{distId}", params["distId"] + "");

      options.headers = {
        Authorization: params["authorization"],
        ...options.headers,
      };
      const configs: IRequestConfig = getConfigs(
        "get",
        "application/json",
        url,
        options
      );
      configs.params = { onlyActiveUsers: params["onlyActiveUsers"] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Get the ecg list by study report in CSV format
   */
  static infoGetEcgListReportByStudy(
    params: {
      /** study id linked to the requested ecg */
      studyId: string;
      /** The date from which to return the ECG list report (yyyy-MM-dd) */
      fromDate?: string;
      /** The date until which to return the ECG list report (yyyy-MM-dd) */
      toDate?: string;
      /** access token */
      authorization?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_GetFollowUpReportDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/info/reports/ecglist/study";

      options.headers = {
        Authorization: params["authorization"],
        ...options.headers,
      };
      const configs: IRequestConfig = getConfigs(
        "get",
        "application/json",
        url,
        options
      );
      configs.params = {
        studyId: params["studyId"],
        fromDate: params["fromDate"],
        toDate: params["toDate"],
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Get the ecg list report in CSV format
   */
  static infoGetEcgListReportByEntity(
    params: {
      /** distributor id of the entity requested for the report */
      distId: number;
      /** The date from which to return the ECG list report (yyyy-MM-dd) */
      fromDate?: string;
      /** The date until which to return the ECG list report (yyyy-MM-dd) */
      toDate?: string;
      /** access token */
      authorization?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_GetFollowUpReportDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/info/reports/ecglist/entity";

      options.headers = {
        Authorization: params["authorization"],
        ...options.headers,
      };
      const configs: IRequestConfig = getConfigs(
        "get",
        "application/json",
        url,
        options
      );
      configs.params = {
        distId: params["distId"],
        fromDate: params["fromDate"],
        toDate: params["toDate"],
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Get the ecg list of the authenticated SA user
   */
  static infoGetStandaloneOrganizationEcgListReport(
    params: {
      /** The date from which to return the ECG list report (yyyy-MM-dd) */
      fromDate?: string;
      /** The date until which to return the ECG list report (yyyy-MM-dd) */
      toDate?: string;
      /** access token */
      authorization?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_GetFollowUpReportDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/info/reports/ecglist/me";

      options.headers = {
        Authorization: params["authorization"],
        ...options.headers,
      };
      const configs: IRequestConfig = getConfigs(
        "get",
        "application/json",
        url,
        options
      );
      configs.params = {
        fromDate: params["fromDate"],
        toDate: params["toDate"],
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static infoGetApiVersion(
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_String> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/info/version";

      const configs: IRequestConfig = getConfigs(
        "get",
        "application/json",
        url,
        options
      );

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static infoGetLatestFirmwareVersion(
    params: {
      /**  */
      deviceFwVersion?: number;
      /**  */
      deviceId?: number;
      /** access token */
      authorization?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_GetLatestFirmwareDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/info/fwversion";

      options.headers = {
        Authorization: params["authorization"],
        ...options.headers,
      };
      const configs: IRequestConfig = getConfigs(
        "get",
        "application/json",
        url,
        options
      );
      configs.params = {
        deviceFwVersion: params["deviceFwVersion"],
        deviceId: params["deviceId"],
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}
